(function () {
  'use strict';

  function normalizeHandle(value) {
    return String(value || '')
      .toLowerCase()
      .trim()
      .replace(/\s+/g, '-');
  }

  function updateCardImages(quickBuyEl, variant) {
    const templatesHost = quickBuyEl.querySelector('[data-js-quick-buy-variant-images]');
    if (!templatesHost || !variant) return;

    const tplByVariant = templatesHost.querySelector(
      'template[data-quickbuy-variant-id="' + variant.id + '"]'
    );

    let tpl = tplByVariant;

    // fallback pe option1 (de regulă culoare)
    if (!tpl && variant.option1) {
      const key = normalizeHandle(variant.option1);
      tpl = templatesHost.querySelector('template[data-quickbuy-option1="' + key + '"]');
    }

    if (!tpl) return;

    const productItem = quickBuyEl.closest('.product-item');
    if (!productItem) return;

    const imageRoot = productItem.querySelector('[data-js-product-item-image]');
    if (!imageRoot) return;

    // Dacă ai slider în card (thumbnail gallery ON)
    const slider = imageRoot.querySelector('css-slider.product-item__slider');
    if (slider) {
      const grid = slider.querySelector('.grid.grid--slider');
      if (grid) {
        grid.innerHTML = tpl.innerHTML;

        // Reinițializare dacă componenta o suportă
        if (typeof slider.update === 'function') slider.update();
        if (typeof slider.init === 'function') slider.init();
      }
      return;
    }

    // Dacă e single-image (fără slider)
    const firstFigure = imageRoot.querySelector('.product-item__image-figure');
    if (firstFigure) {
      const temp = document.createElement('div');
      temp.innerHTML = tpl.innerHTML.trim();
      const first = temp.firstElementChild;
      if (first) firstFigure.replaceWith(first);
    }
  }

  function bindQuickBuy(quickBuyEl) {
    if (quickBuyEl.__qbVariantImgBound) return;
    quickBuyEl.__qbVariantImgBound = true;

    const variantDataEl = quickBuyEl.querySelector('[data-js-variant-data]');
    if (!variantDataEl) return;

    let currentId = null;

    function readVariant() {
      try {
        return JSON.parse(variantDataEl.textContent || '{}');
      } catch (e) {
        return null;
      }
    }

    function apply() {
      const v = readVariant();
      if (!v || !v.id) return;
      if (v.id === currentId) return;
      currentId = v.id;
      updateCardImages(quickBuyEl, v);
    }

    apply();

    const obs = new MutationObserver(apply);
    obs.observe(variantDataEl, { childList: true, characterData: true, subtree: true });
  }

  function boot() {
    document.querySelectorAll('quick-buy[data-js-product-component]').forEach(bindQuickBuy);

    // prinde și quick-buy-uri randate ulterior
    const rootObs = new MutationObserver(function () {
      document.querySelectorAll('quick-buy[data-js-product-component]').forEach(bindQuickBuy);
    });
    rootObs.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();